import cx from 'classnames'

import { DeviceAudioUnsupportedError } from '@src/app/components/audio-device'
import { ErrorBoundary } from '@src/app/error'
import type { ErrorBoundaryErrorHandler } from '@src/app/error'
import { noop } from '@src/lib/fn'
import { logError } from '@src/lib/log'
import type { ThemeKey } from '@src/theme'
import { themeClassNames } from '@ui/theme'

import AudioSettingsForm from './AudioSettingsForm'
import * as styles from './AudioSettingsModal.css'
import AudioSettingsModalError from './AudioSettingsModalError'

interface AudioSettingsModalProps extends React.HTMLProps<HTMLDivElement> {
  allowTesting?: boolean
  tooltipMode?: ThemeKey
}

const AudioSettingsModal = function ({
  allowTesting = true,
  tooltipMode,
  className,
  ...props
}: AudioSettingsModalProps) {
  const handleError: ErrorBoundaryErrorHandler = (error: Error, info) => {
    if (error instanceof DeviceAudioUnsupportedError) {
      return noop()
    }
    logError(error, info)
  }
  return (
    <div {...props} className={cx(themeClassNames.dark, styles.root, className)}>
      <ErrorBoundary onError={handleError} FallbackComponent={AudioSettingsModalError}>
        <AudioSettingsForm allowTesting={allowTesting} tooltipMode={tooltipMode} />
      </ErrorBoundary>
    </div>
  )
}

export default AudioSettingsModal
